import { MAX_BONES } from './webgl2/bone-ubo';
import { glsl } from './shader-glsl';

export const LIT_FLAT_VS = glsl`#version 300 es
precision highp float;

layout(location = 0) in vec3 a_position;
layout(location = 1) in vec3 a_normal;
layout(location = 2) in vec2 a_uv;

#ifdef INSTANCED
layout(location = 3) in vec4 a_modelCol0;
layout(location = 4) in vec4 a_modelCol1;
layout(location = 5) in vec4 a_modelCol2;
layout(location = 6) in vec4 a_modelCol3;
layout(location = 7) in vec4 a_iUvRect;
layout(location = 8) in vec4 a_iTint;
#else
uniform mat4 u_model;
uniform vec4 u_uvRect;
uniform vec3 u_tint;
#endif

#ifdef SKINNED
layout(location = 9) in uvec4 a_boneIndices;
layout(location = 10) in vec4 a_boneWeights;

layout(std140) uniform BoneUBO {
  mat4 u_bones[${MAX_BONES}];
};
#endif

uniform mat4 u_view;
uniform mat4 u_proj;

out vec3 v_normal;
out vec2 v_uv;
out vec3 v_tint;

void main() {
#ifdef INSTANCED
  mat4 m = mat4(a_modelCol0, a_modelCol1, a_modelCol2, a_modelCol3);
  vec4 r = a_iUvRect;
  v_tint = a_iTint.rgb;
#else
  mat4 m = u_model;
  vec4 r = u_uvRect;
  v_tint = u_tint;
#endif

#ifdef SKINNED
  mat4 skin = u_bones[a_boneIndices.x] * a_boneWeights.x
            + u_bones[a_boneIndices.y] * a_boneWeights.y
            + u_bones[a_boneIndices.z] * a_boneWeights.z
            + u_bones[a_boneIndices.w] * a_boneWeights.w;
  vec4 vertPos = skin * vec4(a_position, 1.0);
  vec3 vertNor = mat3(skin) * a_normal;
#else
  vec4 vertPos = vec4(a_position, 1.0);
  vec3 vertNor = a_normal;
#endif

  v_normal = mat3(m) * vertNor;
  v_uv = r.xy + a_uv * r.zw;
  gl_Position = u_proj * u_view * m * vertPos;
}
`;

export const LIT_FLAT_FS = glsl`#version 300 es
precision mediump float;

in vec3 v_normal;
in vec2 v_uv;
in vec3 v_tint;

uniform sampler2D u_atlas;
uniform vec3 u_lightDir;
uniform vec3 u_lightColor;
uniform vec3 u_skyColor;
uniform vec3 u_groundColor;

out vec4 outColor;

void main() {
  vec3 n = normalize(v_normal);
  float ndl = max(dot(n, u_lightDir), 0.0);
  float t = 0.5 + 0.5 * n.y;
  vec3 ambient = mix(u_groundColor, u_skyColor, t);
  vec3 albedo = texture(u_atlas, v_uv).rgb * v_tint;
  vec3 col = albedo * (ambient + u_lightColor * ndl);
  outColor = vec4(col, 1.0);
}
`;

export const SHADER_DEFINES = {
  INSTANCED: 1 << 0,
  SKINNED: 1 << 1,
} as const;
